import _ from 'lodash';
import React from 'react';

type InputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface State {
    value: string;
}

/**
 * Implementation of controlled text input that debounces the supplied onchange without debouncing the display state updates which caused issues.
 * All value instances are toString()ed as text input is the only one supported by this component
 */
class DebouncedTextInput extends React.Component<InputProps, State> {
    private externalOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;

    constructor(props: InputProps) {
        super(props);

        const value = this.props.value !== undefined ? this.props.value.toString() : '';
        this.state = { value };

        this.onChange = this.onChange.bind(this);
    }

    public componentDidMount() {
        const value = this.props.value !== undefined ? this.props.value.toString() : '';
        this.setState({ value });
        this.externalOnChange = _.debounce(this.props.onChange, 500, { leading: false, trailing: true });
    }

    public componentWillReceiveProps(nextProps: InputProps) {
        if (this.props.value === nextProps.value) return;

        const value = nextProps.value !== undefined ? nextProps.value.toString() : '';
        this.setState({ value });
    }

    public render() {
        return <input {...this.props} type="text" onChange={this.onChange} value={this.state.value} />;
    }

    private onChange(event: React.ChangeEvent<HTMLInputElement>) {
        event.persist();
        this.setState({ value: event.currentTarget.value });
        this.externalOnChange(event);
    }
}

export default DebouncedTextInput;



// WEBPACK FOOTER //
// ./src/components/global/form/DebouncedTextInput.tsx